'use strict';

var Modal = require('./modal');

$('body').on('click tap', '.js-keep-shopping', function (e) {
  e.preventDefault();
  var goToHome = $('body').hasClass('page-account');
  if (!goToHome) {
    Modal.close();
    return;
  }
  window.location.href = '/';
});
